import React from 'react';
import {GlobalProvider} from './globalProvider';

import TopMenu from './topMenu/TopMenu';

import {
  HashRouter,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import {
  Home,
  Credito,
  Ranking,
  Game,
  NotFound
} from './Pages';

import Music from './music/Music';
import Config from './config/Config';


import './App.css';

function App(){
  return(
    <GlobalProvider>
      <Music/>
      <div className="App column centerItens">
        <HashRouter>
          <header className="column centerItens">
            <img className="logoEIC" src={'/app/infocovidturbo/images/eic/logo.png'} alt="logo"/>
            <div className = 'titleGame row nowrap spaceAroundContent'>
              <div>
                <span className=" colorEIC strokeTitle">Info</span>
                <span className=" colorEIC strokeTitle colorEICRed">Covid</span>
                <span className=" colorEIC strokeTitle">Turbo</span>
              </div>
              <div className = 'configButton'><Config/></div>
            </div>
            <TopMenu/>
          </header>
          <div className="main row nowrap spaceAroundContent centerItens">
            <Switch>
              <Redirect exact from="/" to="/inicio"/>
              <Route path="/inicio" component={Home}/>
              <Route path="/game/:gameName" component={Game}/>
              <Route path="/Rank" component={Ranking}/>
              <Route path="/creditos" component={Credito}/>
              <Route component={NotFound}/>
            </Switch>
          </div>
        </HashRouter>
      </div>
    </GlobalProvider>
  );
}

export default App;
